export const zDesktopBanner = 2;
export const zHeaderNotifications = 4;
// The ≤767 top bar is sticky: above the pages' in-flow popovers (the
// profile's z-50 Accounts menu and withdraw popup scroll under it), below
// FooterMobile's z-250 bottom nav, the AI panel and blocking modals.
export const zMobileTopBar = 200;
export const zCookiesBannerMoreThenIntercom = 2147483005;

// Above FooterMobile's fixed z-250 bottom nav (the popup's lower half — the
// medals row — must paint and hit-test over it on ≤767px), below coach-marks
// and modals.
export const zCandidatePopup = 300;
// Deliberately below zModalsWr: blocking modals (GDPR, stake, create-signal…)
// must always win over onboarding coach-marks. Coach-marks additionally
// unmount entirely while any Modal is open (useAnyModalOpen), so this order
// is the visual fallback, not the primary mechanism.
export const zCoachmark = 990;
// Above FooterMobile's fixed z-250 bottom nav (the prediction-closing
// snackbar floats just above it on ≤767px), below blocking modals.
export const zClosingSnackbar = 300;
export const zModalsWr = 999;
// Above zModalsWr: the gateway-outage banner and the stale-bundle Reload
// banner are the surfaces that must stay visible over any open modal —
// outage feedback and the reload prompt outrank modal chrome.
export const zOverModalBanner = 1000;
// Tooltips are hover-transient and anchored to their trigger, so they clear
// every layer a trigger can sit in, blocking modals included: a Base UI
// portal opened inside a modal lands beside the modal's wrapper, not
// inside its stacking context, so without this it would paint under it.
export const zTooltip = 1001;
// The ≤767 AI sheet with its scrim: over the sticky top bar (200), the
// bottom nav (250) and the closing snackbar / candidate popup (300) — the
// scrim dims all of them — below coach-marks (990) and blocking modals.
export const zAiSheet = 400;
// The ≤767 fullscreen chart layer shares the AI sheet's tier: never both
// open — the sheet opens only after the layer has closed.
export const zFullscreenChart = 400;
// The AI thread's message menu portals to body, so it must clear every
// surface a thread lives in — the z-260 desktop panels and the ≤767 AI
// sheet — and stay below coach-marks and blocking modals.
export const zAgentMessageMenu = 410;
